import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {LovValueSummary} from "../model/lovValueSummary.model";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class LovValueCacheService {
    public values$: Observable<LovValueSummary[]> = new BehaviorSubject([]);

    putManyInCache(lovValueSummaries: LovValueSummary[]) {
        lovValueSummaries.forEach(lovValueSummary => this.putInCache(lovValueSummary));
    }

    putInCache(lovValueSummary: LovValueSummary) {
        if (! lovValueSummary) {
            return;
        }
        const values = this.snapshot;
        const index = values.findIndex(item => item.id === lovValueSummary.id);
        if (index > -1) {
            values.splice(index, 1);
        }
        values.push(lovValueSummary);
        this.behavior.next(values);
    }

    getByValue(value: string, lovListName = undefined): Observable<LovValueSummary | undefined> {
        return this.values$.pipe(
            map(values => values.find(item =>
                item.value === value &&
                (!lovListName || item.lovListName == lovListName)))
        );
    }

    private get snapshot(): LovValueSummary[] {
        return this.behavior.value;
    }

    private get behavior(): BehaviorSubject<LovValueSummary[]>{
        return this.values$ as BehaviorSubject<LovValueSummary[]>
    }
}